import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { ClubRecentTournPlayerResult } from '@swf/generated/types/api/v0/SwHomeGames';
import { Table } from '@swf/poker';

import {
  TXTCLI_KO__tab,
  TXTCLI_Place,
  TXTCLI_Player,
  TXTCLI_Points,
  TXTCLI_Prize,
  TXTCLI_Rank
} from './ResultsTable.messages.json';
import styles from './ResultsTable.scss';

interface Props {
  results: ClubRecentTournPlayerResult[];
}

interface ResultsData {
  [key: string]: number;
}

const columns = [
  { Header: <Translation {...TXTCLI_Place} />, accessor: 'place' },
  { Header: <Translation {...TXTCLI_Player} />, accessor: 'userId' },
  { Header: <Translation {...TXTCLI_Prize} />, accessor: 'prize' },
  { Header: <Translation {...TXTCLI_Points} />, accessor: 'pointsEarned' },
  { Header: <Translation {...TXTCLI_KO__tab} />, accessor: 'knockouts' },
  { Header: <Translation {...TXTCLI_Rank} />, accessor: 'tournRank' }
];

const ResultsTable: React.FC<Props> = ({ results }) => (
  <div className={styles.container}>
    <Table columns={columns} data={results as ResultsData[]} />
  </div>
);

export default ResultsTable;
